/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-30 15:48:19
 * @LastEditors: K
 * @LastEditTime: 2022-08-31 10:02:32
 */
import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Space } from 'antd';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../app/store';
import { EditableList } from '../../compnents/list/EditableList';
import { NavBar } from '../../compnents/nav/NavBar';
import { stringTrim } from '../../utils/StringUtils';
import styles from "./labelManagementPage.module.css";
import { Columns } from "./columns";
import { LabelModal } from './labelModal';
import { getLabelAdd, getLabelList } from '../tenant/tenantSlice';
import { unwrapResult } from '@reduxjs/toolkit';

export const LabelManagementPage = (): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [pageLoading, setPageLoading] = useState(false)   //表格 loading


  const [labelModalVisible, setLabelModalVisible] = useState(false)   //弹窗 loading

  const [editData, setEditData] = useState<any>()   //编辑 

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getLabelList({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current && getPage()
  }, [params])

  useEffect(() => {
    form.submit()
  }, [])


  return (
    <>
      <NavBar
        style={{ margin: '10px 20px 0' }}
        where={['机构管理', '标签管理']}
        backtrace={{
          name: '机构管理',
          path: '/admin/tenant',
          state: {
            station: '0',
          },
        }}
      />

      {/* 按钮区域 */}
      <Space className={styles.btnWrap}>
        <Button type="primary" onClick={() => setLabelModalVisible(true)}>新增</Button>
      </Space>

      <div className={styles.wrap}>

        {/* 筛选查询区域 */}
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              current: 1
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            className={styles.queryWrap}
          >
            <Space>
              <Form.Item name='name' noStyle getValueFromEvent={stringTrim}>
                <Input
                  allowClear
                  placeholder='请输入标签名称'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>
            </Space>
            <Button type='primary' htmlType='submit'>
              查询
            </Button>
          </Row>
        </Form>

        {/* 表格区域 */}
        <div className={styles.tableWrap}>
          <EditableList
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={Columns(
              (t: any) => {
                console.log(t, 'ttt');
                setEditData(t)
                setLabelModalVisible(true)
              },
              params.size * (params.current - 1),
            )}
            onChangePage={(current: number, size?: number) => setParams({
              ...params,
              current,
              size
            })}
          />
        </div>
      </div>

      <LabelModal
        visible={labelModalVisible}
        editData={editData}
        onOk={(obj) => {
          dispatch(
            getLabelAdd(obj)
          )
            .then(unwrapResult)
            .then(res => {
              setParams({
                ...params,
                current: 1
              })
            })
            .finally(() => {
              setLabelModalVisible(false)
              setEditData(undefined)
            })

        }}
        onCancel={() => {
          setLabelModalVisible(false)
          setEditData(undefined)
        }}
      />


    </>
  );
}

